module.exports = __webpack_public_path__ + "static/media/2.d76ffbf2.jpg";